import { Environment, l10n } from './shared.models';

export const environment: Environment = {
  production: false,
  devTools: true,
  hmr: false,
  name: 'qa-na',
  authEnv: 'qa',
  appUrl: 'https://maps.qa.zonarsystems.net',
  useSettingsApi: false,
  datadog: {
    applicationId: '6f9abbe4-1e1f-4150-b7d9-5f5bef0cb1c0',
    clientToken: 'pub9e3e901f623850797e3a6ece6bf4efda',
    tagEnvironment: 'qa'
  },
  devCycle: {
    clientId: 'dvc_client_6edaef68_748d_4fc5_99a8_d54c9e552d18_3ec3451'
  },
  here: {
    apiKeyV3: 'zRHQYeMWPTut1VrQIirpsuKQqaxgeY7dImB-CE0ND_0'
  },
  openweathermap: {
    apiKey: '254ea8b8424b73b6afb17b2835b436f3',
    opacity: 0.4
  },
  googleTagManager: {
    id: 'GTM-PM9R42P',
    auth: '2KLWSiRQSUBTl0bsYimfIQ',
    environment: 'env-4'
  },
  auth: {
    clientID: 'RzbT6zbqstLZKVI4Sv6Kugd0w51NKdiA',
    domain: 'zonar-qa.auth0.com',
    audience: 'http://apiqa.zonarsystems.net/',
    applicationId: '0f62b543-ecf8-464e-ae6e-5b79f981de6f',
    useRefreshTokens: true,
    maxAge: 36000
  },
  userPreferenceApiBase: {
    url: 'https://api-qa.zonarsystems.net/alert/v1'
  },
  locationApi: {
    url: 'https://location-writer-db.qa.zonarsystems.net',
    assetPropertiesUrl: 'https://location-writer-db.qa.zonarsystems.net'
  },
  autocompleteApi: {
    url: 'https://zonar-nonprod-qa.apigee.net/location-api/autocomplete',
    pageSize: 10
  },
  apiBase: {
    url: 'https://zonar-nonprod-qa.apigee.net'
  },
  coreEntityApiBase: {
    url: 'https://api-qa.zonarsystems.net/core/v1'
  },
  historicalApiBase: {
    url: 'https://gtcx-historical-api.qa.zonarsystems.net/api/v1'
  },
  dataUpdateMessages: {
    // units are minutes
    updateInterval: 1,
    idling: 60 * 12,
    notIdling: 15
  },
  nearbyAssets: {
    searchRadiusMeters: 50 * 1609, // 50 miles in meters
    assetsToReturn: 10
  },
  liveUpdate: {
    pageSize: 150,
    pollingInterval: 10_000,
    consecutiveFailureLimit: 3,
    restartPollingDelay: 30_000
  },
  zTrakBatteryAlertPct: 0.1,
  apiRequestPageSize: 5000,
  datadogSite: 'us5.datadoghq.com',
  minimumTripMS: 60000,
  featureFlags: {
    assetIOs: false
  },
  region: 'NA',
  gtcxUrl: {
    activityFeedUrl: 'https://activity-feed-ui.qa.zonarsystems.net/',
    assetLocator: 'https://asset-locator.qa.zonarsystems.net/'
  },
  i18n: {
    supportedLanguages: ['en-US', 'de-DE', 'en-GB', 'es-ES', 'fr-FR', 'it-IT'],
    defaultLanguage: 'en-US'
  },
  l10n,
  hamburgerMenuEnabled: true
};
